export const defaultStats = {
  endAtHours: 0,
  endAtMinutes: 0,
  maxStudyTimeHours: 0,
  maxStudyTimeMinutes: 0,
  maxStudyTimeSeconds: 0,
  restTimeHours: 0,
  restTimeMinutes: 0,
  restTimeSeconds: 0,
  startAtHours: 0,
  startAtMinutes: 0,
  studyTimeList: [
    {
      name: '',
      studyTimeHours: 0,
      studyTimeMinutes: 0,
      studyTimeSeconds: 0,
    },
  ],
  totalStudyTimeHours: 0,
  totalStudyTimeMinutes: 0,
  totalStudyTimeSeconds: 0,
}
